import React from 'react';
import './StudentReviews.css';
import { Star, Quote } from 'lucide-react';

const reviews = [
  {
    name: 'Anika Sharma',
    photo: 'https://randomuser.me/api/portraits/women/51.jpg',
    review:
      'This course exceeded my expectations! The mentors were phenomenal, and the content was career-transforming.',
    rating: 5,
  },
  {
    name: 'Rahul Nair',
    photo: 'https://randomuser.me/api/portraits/men/53.jpg',
    review:
      'The hands-on approach and real-world examples made learning so much easier. Highly recommended for anyone serious about growth.',
    rating: 4,
  },
  {
    name: 'Sana Qureshi',
    photo: 'https://randomuser.me/api/portraits/women/54.jpg',
    review:
      'Every session felt like a one-on-one mentorship. I feel ready to apply these skills in real projects confidently.',
    rating: 5,
  },
];

const StudentReviews = () => {
  return (
    <section className="student-review-section">
      <div className="student-review-container">
        <div className="student-review-header">
          <Quote className="student-review-icon" />
          <h2 className="student-review-title">Student Reviews</h2>
          <p className="student-review-subtitle">
            Hear from our learners — real experiences, real impact.
          </p>
        </div>

        <div className="student-review-cards">
          {reviews.map((review, index) => (
            <div className="student-review-card" key={index}>
              <div className="student-review-photo-wrapper">
                <img
                  src={review.photo}
                  alt={review.name}
                  className="student-review-photo"
                />
              </div>
              <h3 className="student-review-name">{review.name}</h3>
              <div className="student-review-rating">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={i} size={16} className="student-review-star" />
                ))}
              </div>
              <p className="student-review-text">"{review.review}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StudentReviews;
